import { render, staticRenderFns } from "./selectzh.vue?vue&type=template&id=74074e65&scoped=true&"
import script from "./selectzh.vue?vue&type=script&lang=js&"
export * from "./selectzh.vue?vue&type=script&lang=js&"
import style0 from "./selectzh.vue?vue&type=style&index=0&id=74074e65&lang=less&scoped=true&"
import style1 from "./selectzh.vue?vue&type=style&index=1&id=74074e65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74074e65",
  null
  
)

export default component.exports